import React from "react";
import styles from "./ExpiredNotice.module.scss";

const ExpiredNotice: React.FC = () => {
  return (
    <div className={styles.expired}>
      <p className={styles.expired__p}>Your time finished!!</p>
    </div>
  );
};

export default ExpiredNotice;
